import { render, staticRenderFns } from "./IconDoc.vue?vue&type=template&id=0744cc8d&"
import script from "./IconDoc.vue?vue&type=script&lang=js&"
export * from "./IconDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports